import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import Navigation from "../partials/Navigation";
import { useTranslation } from "react-i18next";
import UserSettings from '../partials/Profile/UserSettings';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import Billing from '../partials/Profile/Billing';
import UserMembership from '../partials/Profile/UserMembership';
import ProfileOptions from '../partials/Profile/ProfileOptions';
import { useCookies } from "react-cookie";
import configVars from "../config";


const ProfileSettings = () => {

	const [translation] = useTranslation("translations");
	const [key, setKey] = useState( 'profile' );
	const { stepStatus } = useParams();

	const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [memberships, setMemberships] = useState({});
    const [source, setSource] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {

		if ( stepStatus === 'saved' ) {
            setKey('billing');
        } else if (stepStatus === 'options') {
			setKey('options');
		}

        if ( ! cookies.sustainyou_user_jwt ) {
            return;
        }

        (async () => {

            let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );

            setLoading(true);

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getstripesubscriptions/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {

                    if ( updateResponse.success === true ) {
                        setSource( updateResponse.data.source );
                        setMemberships( updateResponse.data.subscription_data );
                    }

                    //console.log( updateResponse );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setLoading(false);

        })()

    }, [cookies.sustainyou_user_jwt, stepStatus]);

	return(
		<div className="main-wrapper">
			<Helmet>
				<title>{translation("settings")}</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				
				<HorizontalNav title={translation("settings")} />

				<div className="pt-5 pt-lg-0 page-content-inner">
					<div className="mt-5 d-inline-block w-100">
						<Tab.Container defaultActiveKey={key} activeKey={key} onSelect={ (k) => setKey(k)}>
							<div className="row g-0">
								<div className="col-12">
									<Nav className="w-100 justify-content-center border-bottom">
										<Nav.Item >
											<Nav.Link className={`${ key === 'profile' ? 'border-bottom border-secondary' : ''} text-sy-black`} eventKey="profile">{translation("profile_txt")}</Nav.Link>
										</Nav.Item>
										<Nav.Item >
											<Nav.Link className={`${ key === 'membership' ? 'border-bottom border-secondary' : ''} text-sy-black`} eventKey="membership">{translation("membership_txt")}</Nav.Link>
										</Nav.Item>
										<Nav.Item >
											<Nav.Link className={`${ key === 'billing' ? 'border-bottom border-secondary' : ''} text-sy-black`} eventKey="billing">{translation("billing_txt")}</Nav.Link>
										</Nav.Item>
										<Nav.Item >
											<Nav.Link className={`${ key === 'options' ? 'border-bottom border-secondary' : ''} text-sy-black`} eventKey="options">{translation("settings")}</Nav.Link>
										</Nav.Item>
									</Nav>
								</div>
								<div className="col-12">
									<div className="p-3 p-lg-4 mx-auto"  style={{maxWidth: "1440px"}}>
										<Tab.Content>
											<Tab.Pane eventKey="profile">
												<UserSettings />
											</Tab.Pane>
											<Tab.Pane eventKey="membership">
												<UserMembership loading={loading} memberships={memberships} source={source} />
											</Tab.Pane>
											<Tab.Pane eventKey="billing">
												<Billing defaultPm={memberships?.default_pm} subID={memberships?.id} />
											</Tab.Pane>
											<Tab.Pane eventKey="options">
												<ProfileOptions />
											</Tab.Pane>
										</Tab.Content>
									</div>
								</div>
							</div>
						</Tab.Container>
					</div>

					
				</div>

			</div>

		</div>
	);

}

export default ProfileSettings;